/* eslint-disable no-nested-ternary */
import React, { memo, useState } from 'react'
import prop from 'ramda/src/prop'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import classNames from 'classnames'
import projectListItemConnector from 'root/src/client/logic/project/connectors/projectListItemConnector'
import clipHandler from 'root/src/client/logic/project/handlers/clipHandler'
import withModuleContext from 'root/src/client/util/withModuleContext'
import ShareMenu from 'root/src/client/web/base/ShareMenu'
import CountdownTimer from 'root/src/client/web/base/CountdownTimer'
import unescapeHtml from 'root/src/shared/util/unescapeHtml'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import projectVideoCardAssigneesNamesHandler from 'root/src/client/web/list/util/projectVideoCardAssigneesNamesHandler'
import format2Decimals from 'root/src/shared/util/format2Decimals'
import goToViewCreatorDataHandler from 'root/src/client/logic/creatorData/handlers/goToViewCreatorDataHandler'
import Player from 'root/src/client/web/base/Player'
import { faPlayCircle } from '@fortawesome/pro-regular-svg-icons/faPlayCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TitleFormText from 'root/src/client/web/typography/TitleFormText'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import assigneeRouteSelector from 'root/src/client/logic/project/util/assigneeRouteSelector'
import { colorsNew } from 'root/src/client/web/commonStyles'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import { projectVideoCardStyle } from './style'

const ProjectVideoCard = ({
	projectTitle, projectDescription, classes,	projectAssigneesImages,
	projectShareUrl,	projectGames,	projectAssigneesName,	projectDeliveries,
	pledgeAmount,	goalAmount, timeLeft, key, onChangeItemCallbackArr,
	autoplay, muted, projectAssignees,
}) => {
	const [width] = useWindowSize()
	const [
		titleAssignee, restText,
	] =	projectVideoCardAssigneesNamesHandler(projectAssigneesName, width)
	const [displayPlayer, setPlayer] = useState(false)

	return (
		<div
			key={key}
			className={classNames(
				'flex layout-column',
				classes.cardRoot,
			)}
		>
			{ternary(displayPlayer,
				<Player
					projectDeliveries={projectDeliveries}
					onChangeItemCallbackArr={onChangeItemCallbackArr}
					autoplay={autoplay}
					muted={muted}
					className={classes.player}
				/>,
				<div className={classes.thumbnailWrapper}>
					<div
						className={classes.playIconWrapper}
						onClick={() => setPlayer(true)}
					>
						<FontAwesomeIcon
							icon={faPlayCircle}
							size="7x"
							color="#ffffff"
						/>
					</div>
					<img
						alt="game"
						className={classes.thumbnail}
						src={prop('thumbnail', projectDeliveries)}
						width="540"
						height="303"

					/>
				</div>)}
			<div
				className={classNames(
					'layout-column',
					classes.cardFooter,
				)}
			>
				<div className={classes.footerHeaderContainer}>
					{projectAssigneesImages.map((imgSrc, i) => (i < 3 ? (
						<div
							// eslint-disable-next-line react/no-array-index-key
							key={i}
							onClick={
								() => goToViewCreatorDataHandler(assigneeRouteSelector(projectAssignees[i]))
							}
							className={classes.assigneeImgWrapper}
							style={{ zIndex: 3 - i }}
						>
							<img
								className={classes.assigneeImg}
								src={addHttpsProtocol(imgSrc)}
								alt={`Assignee${i}`}
							/>
						</div>
					) : null))}
					<div
						className={classNames(
							'layout-row layout-align-center',
							classes.projectAssigne,
							classes.overlay,
						)}
						style={{
							display: 'inline-block',
							width: '50%',
							'white-spac': 'nowrap',
							overflow: 'hidden !important',
							'text-overflow': 'ellipsis',
						}}
					>
						<span
							className={classes.assigneesNames}
						>
							<span
								className={classes.pointer}
								onClick={
									() => goToViewCreatorDataHandler(assigneeRouteSelector(projectAssignees[0]))
								}
							>
								<TitleFormText>
									{titleAssignee}
								</TitleFormText>
							</span>
							<span>{restText}</span>
						</span>
					</div>
					<ShareMenu
						url={projectShareUrl}
					/>
				</div>
				<h3 className={classNames(classes.headerTextH3, 'header-element')}>{clipHandler(unescapeHtml(projectTitle), 24)}</h3>
				<div className={classes.descriptionContainer}>
					<span className={classes.descriptionText}>
						<Typography variant={typographyVariants.small}>
							{clipHandler(unescapeHtml(projectDescription), 60)}
						</Typography>
					</span>
				</div>
				<div className={classNames(classes.cardTextContainer)}>
					<Typography
						variant={typographyVariants.micro}
						color={colorsNew.light5}
						className={classes.cardText}
					>
						pledge amount:
					</Typography>
					<span className={classes.cardTextValue}>${format2Decimals(pledgeAmount)}{
						goalAmount ? ` of $${format2Decimals(goalAmount)}` : null}
					</span>
				</div>
				<div className={classNames(classes.cardTextContainer)}>
					<Typography
						variant={typographyVariants.micro}
						color={colorsNew.light5}
						className={classes.cardText}
					>
						game title:
					</Typography>
					<Typography variant={typographyVariants.small} className={classes.cardTextValue}>
						{projectGames.map(({ name }) => clipHandler(name, 36))}
					</Typography>
				</div>
				{timeLeft
					?	(
						<CountdownTimer
							time={timeLeft}
							containerStyle={classes.cardTextContainer}
							textStyle={classes.cardText}
							valueStyle={classes.cardTextValue}
							expiredStyle={classes.expired}
						/>
					)
					:	(
						<div className={classNames(classes.cardTextContainer)}>
							<Typography
								variant={typographyVariants.micro}
								color={colorsNew.light5}
								className={classes.cardText}
							>
								Dare delivered
							</Typography>
						</div>
					)
				}
			</div>
		</div>
	)
}

export default withModuleContext(
	projectListItemConnector(memo(ProjectVideoCard), projectVideoCardStyle, 'MuiProjectVideoCard'),
)
